import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/(protected)/logistic/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/(protected)/logistic/"!</div>;
}
